<!-- has--skew-br -->
<article class="block-service bg-tertiary">
  <app-big-text class="block-service__title text-light" [align]="'left'" [text]="block.title"></app-big-text>
  <div class="container mt-4 mt-md-7">
    <ul *ngIf="block.listItems?.length" class="block-service__list">
      <li
        *ngFor="let service of block.listItems; let i = index; trackBy: trackByFn"
        class="block-service__list__item"
        [class.set--active]="activeIndex$() === i"
        [style.--list-index]="i"
      >
        <a
          [routerLink]="service.button?.routerLink"
          class="mb-3 link-unset block-service__button anim--stagger-list-item anim--stagger-list-item--delay-2 anim--stagger-list-item--step-delay-2 anim--stagger-list-item--to-right"
          (mouseenter)="pause(i)"
          (mouseleave)="start(i)"
        >
          <fstr-icon anchor="icon-arrow-right" class="chip chip--secondary d-none d-md-inline-flex"></fstr-icon>
          <h1 class="service-info__title mb-0">{{ service.title }}</h1>
        </a>

        <div class="service-info__text d-block d-md-none markdown fs-body-lg" *ngIf="service.text" [innerHTML]="service.text | safe"></div>
        <article class="service-info" *ngIf="service.text" (mouseenter)="pause(i)" (mouseleave)="start(i)">
          <div class="anim-fade-up delay--4">
            <h1 class="sr-only">{{ service.title }}</h1>
            <fstr-image
              *ngIf="service.image?.url"
              [imageSizes]="[400, 800, 1400]"
              [image]="service.image!"
              class="service-info__image"
              [alt]="service.image?.alt || service.title || 'block-image'"
            ></fstr-image>
            <div class="service-info__text markdown fs-body-lg" [innerHTML]="service.text | safe"></div>

            <!-- <app-text-shape
              *ngIf="activeIndex$() === i"
              [cssClasses]="'block-services__shape'"
              [autoplay]="true"
              type="standalone"
            ></app-text-shape> -->
          </div>
        </article>
      </li>
    </ul>
  </div>

  <!--<hr class="skew--br" />-->
</article>
